export default {
    apiKey: "AIzaSyByrG76I_PNdM8Bdg5jIsW-qJlqvywOw-Y",
    authDomain: "ace-test-5949b.firebaseapp.com",
    databaseURL: "https://ace-test-5949b.firebaseio.com",
    projectId: "ace-test-5949b",
    storageBucket: "ace-test-5949b.appspot.com",
    messagingSenderId: "118790415803",
    appId: "1:118790415803:web:9603bd82f143595723909e",
    measurementId: "G-B8KV4N5NT5"
};